/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { useField } from 'react-final-form';
import {
  DetailsMaster,
  InfoIcon,
  InfoMaster,
  ModalPage,
  Paper,
} from 'components';
import { MasterInfo, SpecialistCases } from 'types';
import { find } from 'lodash-es';

export const Master: React.FC<{
  masterId?: string;
  masterInfo?: MasterInfo;
  masters?: MasterInfo[];
  widgetId?: string;
  specialistCases: SpecialistCases;
}> = ({ masterId, masterInfo, masters, widgetId, specialistCases }) => {
  const { specialistPrepositionalCase } = specialistCases;
  const masterField = useField('masterId');
  const employeeId = masterId || masterField.input.value;
  const master = masterInfo || find(masters, (item) => item.id === employeeId);

  const [item, setItem] = React.useState<{
    tabIdx: number;
  } | null>(null);
  const resetItem = () => setItem(null);

  const handleOpenDetailsMaster =
    (tabIdx = 0) =>
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      setItem({ tabIdx });
      e.stopPropagation();
    };

  if (!master || master.isShow === false) return null;

  return (
    <>
      <ModalPage
        isOpen={!!item}
        title={`${specialistPrepositionalCase}`}
        onClose={resetItem}
      >
        {item && (
          <DetailsMaster
            {...master}
            widgetId={widgetId}
            tabIndex={item.tabIdx || 0}
          />
        )}
      </ModalPage>
      <Paper>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <InfoMaster {...master} widgetId={widgetId} />
          <IconButton
            rounded="full"
            variant="ghost"
            icon={<InfoIcon />}
            aria-label="Назад в выбор услуг"
            onClick={handleOpenDetailsMaster()}
          />
        </Box>
      </Paper>
    </>
  );
};
